module.exports = __webpack_public_path__ + "img/99.3962a6ad.png";